import { Link, useParams } from 'react-router-dom'

import { JobOfferApplication } from '../containers/job-offers'
import { useI18N } from '../../libraries/i18n/hook'
import Button from '../components/form/Button'
import { useJobOffer, useLatestAcademicTranscript } from '../containers/job-offers/hooks'
import Loading from '../components/layout/Loading'
import PageHeading from '../components/layout/PageHeading'
import ErrorMessage from '../components/errors/ErrorMessage'
import NoResults from '../components/layout/NoResults'
import { useCVForOffer } from '../containers/cv/hooks'

const JobOfferApplicationPage = () => {
  const { id } = useParams()
  const { t } = useI18N()
  if(!id) return <div>Invalid job offer id</div>
  const { data: jobOffer, isLoading: isLoadingJobOffer } = useJobOffer(parseInt(id))
  const { data: latestJobOfferApplication, error: latestJobOfferApplicationError, isLoading: isLoadingLatestJobOfferApplication } = useCVForOffer(id ? parseInt(id) : undefined)
  const { data: latestAcademicTranscript } = useLatestAcademicTranscript()

  if(isLoadingJobOffer || isLoadingLatestJobOfferApplication) {
    return <Loading size='fill-container' />
  }

  if(!jobOffer || latestJobOfferApplicationError) {
    return (
      <div className='flex items-center flex-col'>
        {latestJobOfferApplicationError ? (
          <ErrorMessage message={latestJobOfferApplicationError} />
        ) : (
          <NoResults />
        )}
        <Link to='/jobs' className='mt-4' replace><Button>{t('common.backTo')} {t('jobs.title')}</Button></Link>
      </div>
    )
  }

  return (
    <div className='w-full rounded-md px-6 py-4 max-w-4xl mx-auto bg-white'>
      <PageHeading>{jobOffer.title} @ {jobOffer?.company.name}</PageHeading>
      {jobOffer.company.name && (
        <JobOfferApplication
          id={id}
          companyName={jobOffer.company.name}
          workShiftLabel={jobOffer.workShiftType?.name}
          isInternship={jobOffer.isInternship}
          isLoading={isLoadingJobOffer}
          latestCvUrl={latestJobOfferApplication?.cvUrl}
          latestAcademicTranscript={latestAcademicTranscript}
          customFields={jobOffer.applicationFields}
          confirmLocation={jobOffer.confirmLocation}
          countryName={jobOffer.city.country.name}
        />
      )}
    </div>
  )
}

export default JobOfferApplicationPage
